/* eslint-disable import/no-extraneous-dependencies */
import jQuery from 'jquery';

// The vendored bundles in lib/ read a bare `jQuery` identifier, which resolves via the global
// scope. Publishing it here replaces the imports-loader injection, whose query syntax differs
// irreconcilably between the v0.7 (legacy MSBuild) and v4 (BuildXL) build arms.
if (typeof window !== 'undefined' && !window.jQuery) {
  window.jQuery = jQuery;
}
